var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBCabinetPartnersUsdtIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07969 7.47187V7.47031C8.99375 7.47656 8.55078 7.50313 7.5625 7.50313C6.77344 7.50313 6.21797 7.47969 6.02266 7.47031V7.47266C2.98516 7.33906 0.717968 6.81016 0.717968 6.17734C0.717968 5.54531 2.98516 5.01641 6.02266 4.88047V6.94609C6.22109 6.96016 6.78984 6.99375 7.57578 6.99375C8.51875 6.99375 8.99141 6.95469 9.07969 6.94688V4.88203C12.1109 5.01719 14.3727 5.54609 14.3727 6.17734C14.3727 6.81016 12.1109 7.3375 9.07969 7.47187V7.47187ZM9.07969 4.66719V2.81875H13.3094V0H1.79297V2.81875H6.02266V4.66641C2.58516 4.82422 0 5.50547 0 6.32109C0 7.13672 2.58516 7.81719 6.02266 7.97578V13.8992H9.07969V7.97422C12.5117 7.81641 15.0906 7.13594 15.0906 6.32109C15.0906 5.50625 12.5117 4.82578 9.07969 4.66719",
    fill: "#FF592E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCabinetPartnersUsdtIcon);
export default __webpack_public_path__ + "static/media/b_cabinet_partners_usdt_icon.4b89074e6cfdcc01f8c5050f9ec7a6b3.svg";
export { ForwardRef as ReactComponent };